export enum Locations {
  CANADA = 'CAN',
  UNITED_STATES = 'USA'
}

export const LOCATION = process.env.REACT_APP_LOCALE || Locations.UNITED_STATES;
